import $ from 'jquery';
import utils from '../utils/index.js';

const useSearch = el => {
  const target = document.querySelector(`[cm-search=${el}]`);
  const result = document.querySelector(`[cm-result=${el}]`);
  if (target && result && $(target).find('input')) {
    const $target = $(target);
    const $result = $(result);
    const $input = $target.find('input');
    const $clean = $target.find('[cm-clean]');
    $clean.on('click', () => {
      $input.val('');
      $input.trigger('focus');
      $result.empty();
      $target.removeClass('has-content')
    });
    
    const searchObj = {
      target,
    };
    //输入时回调
    searchObj.onSearch = fn => {
      $input
        .off()
        .on(
          'input',
          utils.debounce(e => {
            if (!e.currentTarget.selectCN && $input.val().length > 1) {
              fn(el, $input.val());
              $target.addClass('has-content')
            } else {
              $result.empty();
              $target.removeClass('has-content')
            }
          }, 500),
        )
        .on('compositionstart', e => {
          e.currentTarget.selectCN = true;
        })
        .on('compositionend', e => {
          e.currentTarget.selectCN = false;
        })
    };

    //选中时回调

    searchObj.result = result => {
      $result.html(result)
    };
    return searchObj;
  } else {
    return null;
  }
};

export default useSearch;
